export default "__VITE_ASSET__3851be63__"